export default "<p>select-reward works!</p>\n";